import {
  Component,
  ChangeDetectionStrategy,
  forwardRef,
  Injector,
  Input,
  ViewChild,
  ViewEncapsulation,
  ElementRef,
  Output,
  EventEmitter
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputBase } from '../_shared/base.class';
import * as rangeSlider from 'rangeslider-pure';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'sc-range-slider',
  templateUrl: './range-slider.component.html',
  styleUrls: ['./range-slider.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    DecimalPipe,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RangeSliderComponent),
      multi: true
    }
  ]
})
export class RangeSliderComponent extends InputBase {
  @Input() min = 0;
  @Input() max = 100;
  @Input() step = 1;
  @Input() prefix: string;
  @Input() sufix: string;
  @Input() maxPlus = true;
  @Input() minPlus = true;

  @Output() onupdate: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('num', { static: false }) inputValue: ElementRef;
  @ViewChild('range', { static: false }) set range(e) {
    this.initControl(e.nativeElement);
  }

  numValue: number;

  constructor(
    injector: Injector,
    private numPipe: DecimalPipe,
    private element: ElementRef
  ) {
    super(injector);
  }

  onFocus(focused: boolean, e: Event) {
    this.setActive(!!focused || !!(e.target as HTMLInputElement).value);
  }

  writeValue(delta: any): void {
    this.updateTextValue(delta);
    this._value = delta;
  }

  changeValue(value: any): void {
    this.writeValue(value);
    this.onChange(value);
    this.onupdate.emit(value);
    this.cdr.detectChanges();
  }

  initControl(slider) {
    rangeSlider.create(slider, {
      polyfill: true, // Boolean, if true, custom markup will be created
      root: this.element.nativeElement,
      rangeClass: 'rangeSlider',
      disabledClass: 'rangeSlider--disabled',
      fillClass: 'rangeSlider__fill',
      bufferClass: 'rangeSlider__buffer',
      handleClass: 'rangeSlider__handle',
      startEvent: ['mousedown', 'touchstart', 'pointerdown'],
      moveEvent: ['mousemove', 'touchmove', 'pointermove'],
      endEvent: ['mouseup', 'touchend', 'pointerup', 'mouseleave'],
      vertical: false, // Boolean, if true slider will be displayed in vertical orientation
      min: null, // Number , 0
      max: null, // Number, 100
      step: this.step, // Number, 1
      value: this.value, // Number, center of slider
      buffer: null, // Number, in percent, 0 by default
      stick: null, // [Number stickTo, Number stickRadius] : use it if handle should stick to stickTo-th value in stickRadius
      borderRadius: 10, // Number, if you use buffer + border-radius in css for looks good,
      onInit: () => this.updateTextValue(this.value),
      onSlide: position => this.updateTextValue(position),
      onSlideEnd: position => this.changeValue(position)
    });

    slider.rangeSlider.update(
      {
        min: this.min - +this.minPlus,
        max: this.max + +this.maxPlus,
        step: this.step,
        value: this.value
      },
      true
    );
  }

  private updateTextValue(value: number = this.value) {
    if (!this.inputValue || !this.inputValue.nativeElement) {
      return;
    }

    let prefix = this.prefix;
    if (this.max < value) {
      value = this.max;
      prefix = 'więcej niż ';
    }

    if (this.min > value) {
      value = this.min;
      prefix = 'mniej niż ';
    }

    const num = this.numPipe.transform(value, '1.0-0');
    this.inputValue.nativeElement.innerHTML = `<span>${prefix}</span> ${num}`;
  }
}
